// extracted by mini-css-extract-plugin
export default {"root":"IconMail_root__mQQ9r"};